import {findKeyByValue, scrollIntoView, getSortedChildren} from '../UtilService'

export const getFormFields = () => {
  return {
    defaultError: '',
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password: '',
    referral: '',
    ssn: '',
    birthDate: '',
    line1: '',
    line2: '',
    postalCode: '',
    city: '',
    state: '',
    segment: '',
    checkbox: '',
    businessName: '',
    registeredState: '',
    ein: '',
    ownershipPercent: ''
  }
}

export const scrollToServerErrorBySection = (refs, fieldNameSectionMap, fieldName) => {
  const refName = findKeyByValue(fieldNameSectionMap, fieldName)
  const elSection = refs[refName]
  if (!elSection) return
  scrollIntoView(elSection)
}

export const scrollToServerErrorByInput = (refs, fieldName) => {
  const $elInput = refs[fieldName]
  if (!$elInput) return
  scrollIntoView($elInput.$el)
}

// Helper function to validate a component
export const validateCmp = (cmp) => cmp.validate && !cmp.validate()

export const isCmpVInput = ({ $el }) =>
  Array.from($el.classList).includes('v-input')

// Helper function to find the first invalid section in the form
const findInvalidSection = (formChildren) => {
  return getSortedChildren(formChildren).find((cmp) => {
    console.log(cmp, isCmpVInput(cmp), validateCmp(cmp))
    if (isCmpVInput(cmp) && validateCmp(cmp)) {
      return true
    }
    return cmp.$children.some(validateCmp)
  })
}

// Main function to find and scroll to the first form error
export const findAndScrollToFormError = ($elForm, noSections = false) => {
  const $elSection = findInvalidSection($elForm.$children)
  if (!$elSection) return
  const isVInput = isCmpVInput($elSection)
  scrollIntoView(
    noSections || $elSection.$el.classList.contains('main-footer-wrapper')
      ? $elSection.$el
      : isVInput
        ? $elSection.$el.parentElement.parentElement
        : $elSection.$el.parentElement
  )
}



// WEBPACK FOOTER //
// ./src/services/entities/errorService.js